import { Outlet } from 'react-router-dom';
import { AuthModal } from '@/features/auth';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';

/** Public shell: brand header (nav · theme · subscribe · account) + footer around the routed page. */
export function RootLayout() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground antialiased">
      <SiteHeader />
      <main>
        <Outlet />
      </main>
      <SiteFooter />
      <AuthModal />
    </div>
  );
}
